import GoogleTagManagerHelper from '@tracking/gtm-helper';

let lastPage: string;
export const trackView = (view: string, type: string) => {
  const pageName = `/${window.competitionUrl}/addToCalendar/${view}/`;
  if (lastPage === pageName) return;
  lastPage = pageName;

  const gtmNewsletterFormInfo = {
    pageName,
    virtPath: pageName,
    page_type: type,
    page_subtype: 'add to calendar',
    competition: window.competitionTracking,
    content_section_1: window.competitionTracking,
    content_section_2: 'addtocalendar',
  };
  GoogleTagManagerHelper.addPageMeta(gtmNewsletterFormInfo);
  GoogleTagManagerHelper.addVirtualPage(gtmNewsletterFormInfo);
};
